"use strict";
/* tslint:disable */
/* eslint-disable */
/**
 * RichWise_Website_API.API
 * No description provided (generated by Openapi Generator https://github.com/openapitools/openapi-generator)
 *
 * The version of the OpenAPI document: 1.0
 *
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */
Object.defineProperty(exports, "__esModule", { value: true });
exports.instanceOfCompanyInformationEditViewModel = instanceOfCompanyInformationEditViewModel;
exports.CompanyInformationEditViewModelFromJSON = CompanyInformationEditViewModelFromJSON;
exports.CompanyInformationEditViewModelFromJSONTyped = CompanyInformationEditViewModelFromJSONTyped;
exports.CompanyInformationEditViewModelToJSON = CompanyInformationEditViewModelToJSON;
exports.CompanyInformationEditViewModelToJSONTyped = CompanyInformationEditViewModelToJSONTyped;
/**
 * Check if a given object implements the CompanyInformationEditViewModel interface.
 */
function instanceOfCompanyInformationEditViewModel(value) {
    if (!('ciCompanyName' in value) || value['ciCompanyName'] === undefined)
        return false;
    if (!('ciWebsiteRenderingName' in value) || value['ciWebsiteRenderingName'] === undefined)
        return false;
    if (!('ciManIntroduction' in value) || value['ciManIntroduction'] === undefined)
        return false;
    return true;
}
function CompanyInformationEditViewModelFromJSON(json) {
    return CompanyInformationEditViewModelFromJSONTyped(json, false);
}
function CompanyInformationEditViewModelFromJSONTyped(json, ignoreDiscriminator) {
    if (json == null) {
        return json;
    }
    return {
        'ciCompanyNo': json['ciCompanyNo'] == null ? undefined : json['ciCompanyNo'],
        'ciCompanyName': json['ciCompanyName'],
        'ciWebsiteRenderingName': json['ciWebsiteRenderingName'],
        'ciManIntroduction': json['ciManIntroduction'],
        'ciRemark': json['ciRemark'] == null ? undefined : json['ciRemark'],
        'ciUseStatus': json['ciUseStatus'] == null ? undefined : json['ciUseStatus'],
        'ciDisabledDate': json['ciDisabledDate'] == null ? undefined : json['ciDisabledDate'],
        'ciLineId': json['ciLineId'] == null ? undefined : json['ciLineId'],
    };
}
function CompanyInformationEditViewModelToJSON(json) {
    return CompanyInformationEditViewModelToJSONTyped(json, false);
}
function CompanyInformationEditViewModelToJSONTyped(value, ignoreDiscriminator = false) {
    if (value == null) {
        return value;
    }
    return {
        'ciCompanyNo': value['ciCompanyNo'],
        'ciCompanyName': value['ciCompanyName'],
        'ciWebsiteRenderingName': value['ciWebsiteRenderingName'],
        'ciManIntroduction': value['ciManIntroduction'],
        'ciRemark': value['ciRemark'],
        'ciUseStatus': value['ciUseStatus'],
        'ciDisabledDate': value['ciDisabledDate'],
        'ciLineId': value['ciLineId'],
    };
}
